<template>
	<div class="custom">
		<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
		<div class="cards" v-if="theme == 'blue' || theme == 'yellow'" :style="customData.length != 3 ? 'justify-content: center;' : ''">
			<div class="card" v-for="(item, index) in customData" :key="index">
				<div v-if="item.icon" class="index">
					<img :src="item.icon.replace('/public', '')" />
				</div>
				<div :class="[language === 'zh' ? 'zh_text' : 'en_text']">{{ item.content }}</div>
			</div>
		</div>
		<div class="cards" v-else :style="customData.length != 3 ? 'justify-content: center;' : ''">
			<div class="card" :class="'card' + index" v-for="(item, index) in customData" :key="index">
				<div v-if="item.icon" class="index" :style="{ background: getBackgroundColor(index) }"><img :src="item.icon.replace('/public', '')" /></div>
				<div :class="[language === 'zh' ? 'zh_text' : 'en_text']">{{ item.content }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import Title from '@/components/title.vue'
import { mapState } from 'vuex'

export default {
	name: 'Custom1',
	components: {
		Title,
	},
	props: {
		index: {
			type: Number,
		},
	},
	data() {
		return {
			pageData: {},
			customData: [],
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData']),
	},
  watch:{
    language(newVal, oldVal) {
      this.initData();
    }
  },
	mounted() {
		this.initData();
	},
	methods: {
    initData() {
      let data = JSON.parse(this.jsonData.moduleData)
      if (this.language == 'zh') {
        data = JSON.parse(this.jsonData.moduleData)
        this.customData = JSON.parse(this.jsonData.diyData1)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
        this.customData = JSON.parse(this.jsonData.diyData1Eng)
      }
      this.pageData = data[this.index]
    },
		getBackgroundColor(index) { // 获取背景颜色
			if (this.theme == 'red') { // 红色
				return index == 0 || index == 3 ? '#d32f2e' : '#2D3E50'
			} else if (this.theme == 'purple') { // 紫色
				if (index === 0) {
					return '#F9CD70'
				} else if (index === 1) {
					return '#9FA1E1'
				} else if (index === 2) {
					return '#8BCAEA'
				} else if (index === 3) {
					return '#F3ADBF'
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.red {
	.custom {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
    box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
    box-sizing: border-box;
	}
}

.purple {
	.custom {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
	}
}
.cards {
	margin-top: 24px;
	padding: 0 80px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 24px 82px;
	height: 340px;
}

.card {
	position: relative;
	height: 96px;
	border-radius: 8px;
	display: flex;
	align-items: center;
}
.index {
	width: 86px;
	height: 86px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 100%;
}
.index img {
	width: 34px;
	height: 34px;
}

.zh_text {
	margin-left: 10px;
	width: 302px;
	font-size: 16px;
	font-weight: 400;
	color: var(--timeTitleColor);
	line-height: 22px;

	display: -webkit-box;
	-webkit-line-clamp: 4; /* 设置显示的行数 */
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis; /* 超出部分显示省略号 */
}
.en_text {
	margin-left: 10px;
	width: 302px;
	font-size: 14px;
	font-weight: 400;
	color: var(--timeTitleColor);
	line-height: 20px;

	display: -webkit-box;
	-webkit-line-clamp: 4; /* 设置显示的行数 */
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis; /* 超出部分显示省略号 */
}
.blue {
	.custom {
		padding: 0 80px;
		padding-top: 27px;
		width: 980px;
		height: 489px;
		position: relative;
	}
	.cards {
		margin-top: 34px;
		padding: 0;
		display: flex;
		flex-wrap: wrap;
		//justify-content: center;
		//align-items: center;
		gap: 39px 40px;
	}

	.card {
		position: relative;
		width: 470px;
		height: 168px;
		background: #ecf2fd;
		border-radius: 8px;
		display: flex;
		align-items: center;
	}
	.index {
		margin-left: 20px;
		background: linear-gradient(90deg, #4782ea 0%, #5db6fc 100%);
	}
	.zh_text {
		margin-left: 20px;
		width: 324px;
		font-size: 14px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 20px;

		display: -webkit-box;
		-webkit-line-clamp: 4; /* 设置显示的行数 */
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis; /* 超出部分显示省略号 */
	}
	.en_text {
		margin-left: 20px;
		width: 324px;
		font-size: 14px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 20px;

		display: -webkit-box;
		-webkit-line-clamp: 4; /* 设置显示的行数 */
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis; /* 超出部分显示省略号 */
	}
}

.yellow {
	.custom {
		width: 980px;
		height: 510px;
		padding: 0 80px;
		background: #f5f6f8;
		border-radius: 28px;
		position: relative;
	}
	.cards {
		margin-top: 29px;
		padding: 0;
		display: flex;
		flex-wrap: wrap;
		//justify-content: center;
		//align-items: center;
		gap: 39px 40px;
	}

	.card {
		position: relative;
		width: 470px;
		height: 168px;
		background: #ffffff;
		box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
		border-radius: 8px;
		display: flex;
		align-items: center;
	}
	.index {
		margin-left: 20px;
		background: #edae11;
	}
	.zh_text {
		margin-left: 20px;
		width: 324px;
		font-size: 14px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 20px;

		display: -webkit-box;
		-webkit-line-clamp: 4; /* 设置显示的行数 */
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis; /* 超出部分显示省略号 */
	}
	.en_text {
		margin-left: 20px;
		width: 324px;
		font-size: 14px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 20px;

		display: -webkit-box;
		-webkit-line-clamp: 4; /* 设置显示的行数 */
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis; /* 超出部分显示省略号 */
	}
}
</style>
